import styled, { css } from 'styled-components';

export const SectionWrapper = styled.div(
  ({ theme }) => css`
    grid-area: benefits;

    padding: ${theme.sz.s6} ${theme.sz.s12};
    background-color: ${theme.co.primary99};
    border-radius: ${theme.bo.mediumLarger};
    box-shadow: 0 ${theme.sz.s1} 0 ${theme.co.neutral80};

    @media (max-width: ${theme.sz.lg}) {
      padding: ${theme.sz.s0};
      background-color: unset;
      box-shadow: unset;
    }
  `,
);

export const Table = styled.table(
  () => css`
    width: 100%;
    border-collapse: collapse;
    table-layout: auto;
  `,
);

export const HeaderCell = styled.th(
  ({ theme }) => css`
    white-space: nowrap;
    padding: ${theme.sz.s0};

    &:first-child {
      white-space: wrap;
      width: 100%;
    }
  `,
);

export const Row = styled.tr(
  ({ theme }) => css`
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.primary70};
  `,
);

export const Cell = styled.td(
  ({ theme }) => css`
    &:last-child {
      background-color: ${theme.co.primary20};
    }
  `,
);

export const HeaderCellContent = styled.div<{ $isPro?: boolean }>(
  ({ theme, $isPro }) => css`
    position: relative;
    text-transform: uppercase;
    height: ${theme.sz.s14};
    padding-top: ${theme.sz.s3};
    ${theme.typography.heading.desktop.xxxs};

    ${
      $isPro &&
      css`
        background-color: ${theme.co.primary20};
        border-top-left-radius: ${theme.bo.mediumSmall};
        border-top-right-radius: ${theme.bo.mediumSmall};
      `
    }
  `,
);

export const FreeHeaderText = styled.div(
  ({ theme }) => css`
    position: absolute;
    right: ${theme.sz.s3};
    left: -100vw;
    text-align: end;
  `,
);

export const FeatureCellContent = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
    }
  `,
);

export const CheckmarkCellContent = styled.div(
  ({ theme }) => css`
    height: ${theme.sz.s14};
    width: ${theme.sz.s12};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${theme.sz.s6};
  `,
);

export const Disclaimer = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    color: ${theme.co.secondary50};
    margin: ${theme.sz.s6} ${theme.sz.s0} ${theme.sz.s0};
  `,
);
